// extracted by mini-css-extract-plugin
export var dividerLine = "_7l-3";
export var itemImage = "_7l-9";
export var lightDivider = "_7l-4";
export var modalContent = "_7l-5";
export var modalContentCompact = "_7l-6";
export var productCard = "_7l-a";
export var productImage = "_7l-b";
export var productImageCompact = "_7l-7";
export var productImagePlaceholder = "_7l-c";
export var productImagePlaceholderCompact = "_7l-8";
export var progressBarBackground = "_7l-1";
export var progressBarContainer = "_7l-0";
export var progressBarFill = "_7l-2";